import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PACIFIC_DISABLE_COMMS_AA_EDITORIAL_RECENT_STARTER_SUPRESSION = createFcmDetails(
	'pacific_disable_comms_aa_editorial_recent_starter_supression',
	{
		owner: 'Site Platform',
		context: 'comms stack',
		description: 'Flag used to disable the default 14 day suppression of editorial messages for recent starters.',
		import: false,
	},
);
